module.exports = __webpack_public_path__ + "assets/img/icon.9df556fe.png";